import React, { useState, useEffect } from "react"
import "./cards-description-product.scss"
import flujo from "../../../assets/images/icons_card/Flujo moderado.svg"
import tritech from "../../../assets/images/icons_card/Tritech.svg"
import lavar from "../../../assets/images/icons_card/Lavar panty.svg"
import panty from "../../../assets/images/icons_card/Panty.svg"

const CardsDescriptionProduct = ({ haveShopSecret,flujoType }) => {
  const cards = [
    {
      id: 1,
      img: flujo,
      description: (
        <p>
          {process.env.LOCALE === "es-CL" ? (
            <>
              Si tienes un flujo moderado o leve, tendrás la protección
              adecuada. Su absorción es casi equivalente a dos Toallas Nosotras
              Ultra Invisible o a dos Tampones Nosotras Regular.
            </>
          ) : (
            <>
              Si tienes un flujo {flujoType === 'Abundante' ? <b>abundante</b> : <b>moderado o leve</b> }, tendrás la protección
              adecuada. Su absorción es casi equivalente a {flujoType === 'Abundante' ?4 : 2} toallas Nosotras
              Invisible o a {flujoType === 'Abundante' ? 4 : 2} Tampones Nosotras Regular.
            </>
          )}
        </p>

      ),
    },
    {
      id: 2,
      img: tritech,
      description: (
        <p>
          Con su tecnología Tritech estarás <b>seca, cómoda y libre</b> de
          posibles olores, para sentirte segura y confiada.
        </p>
      ),
    },
    {
      id: 3,
      img: lavar,
      description: (
        <p>
          {process.env.LOCALE === "es-CL" ? (
            <>
              Puedes lavar tu Calzón Reutilizable a <b> mano con agua fría </b>y
              luego lavarlo en la lavadora, así se removerán todos los fluidos.
            </>
          ) : (
            <>
              Puedes lavar tú{" "}
              {process.env.LOCALE === "es-BO" ? "ropa interior" : "Panty"} a{" "}
              <b> mano con agua fría </b>y luego lavas en la lavadora, así se
              removerán todos los fluidos.
            </>
          )}
        </p>
      ),
    },
    {
      id: 4,
      img: panty,
      description: (
        <p>
          {process.env.LOCALE === "es-CL" ? (
            <>
              ¡Usa, lava y reutiliza! Tu Calzón Íntimawear de Nosotras es más{" "}
              <b> sostenible con el medio ambiente.</b>
            </>
          ) : (
            <>
              ¡Usa, lava y reusa! Tu {process.env.LOCALE !== "es-BO" && "Panty"}{" "}
              Íntima Wear de Nosotras es más{" "}
              <b> sostenible con el medio ambiente.</b>
            </>
          )}
        </p>
      ),
    },
  ]
  return (
    <section className="f-card-product-section">
      <div className="f-card-container-scroll">
        <div className="f-card-product-card-container">
          {cards.map(card => (
            <div key={card.id} className="f-card-product-card">
              <div className="f-card-product-card__img">
                <img src={card.img} alt={card.id} />
              </div>
              <div className="f-card-product-card__description">
                {card.description}
              </div>
            </div>
          ))}
        </div>
      </div>
      {haveShopSecret && (
        <div className="f-card-product-title">
          <p>
            ¿Quieres conocer más?{" "}
            {process.env.LOCALE !== "es-CL" && (
              <a
                href={
                  process.env.LOCALE === "es-EC"
                    ? "https://www.tiendanosotras.com.ec/"
                    : "https://www.tiendanosotras.com/"
                }
                target="_blank"
              >
                Ingresa a nuestra tienda virtual
              </a>
            )}
          </p>
        </div>
      )}
    </section>
  )
}

export default CardsDescriptionProduct
